import { Button } from "@obs/base";
import { LocaleIcon } from "@obs/icons";
import { capitalizeFirstLetter, getCountryCode } from "@obs/utils";
import { useState } from "react";

import { getFlagIllustrationIcon } from "./getFlagIllustrationIcon";
import { useLocale } from "./Provider";
import { SwitcherModal, type SwitcherModalProps } from "./SwitcherModal";

export type SwitcherProps = Pick<SwitcherModalProps, "subheader">;

export const Switcher = ({ subheader }: SwitcherProps) => {
	const { locale } = useLocale();
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const formatLanguage = (localeCode: string) => {
		const languageNames = new Intl.DisplayNames([localeCode], {
			type: "language",
			languageDisplay: "standard",
		});
		return capitalizeFirstLetter(languageNames.of(getCountryCode(localeCode)));
	};

	return (
		<>
			<Button.Tertiary
				onClick={() => setIsDialogOpen(true)}
				icon={{
					Component: getFlagIllustrationIcon(locale) || LocaleIcon,
				}}
			>
				{formatLanguage(getCountryCode(locale))}
			</Button.Tertiary>
			<SwitcherModal isDialogOpen={isDialogOpen} setIsDialogOpen={setIsDialogOpen} subheader={subheader} />
		</>
	);
};
